import { HUNTER_URL } from "Components/Hunter/hunterUrl";

// Android-TWA counterpart of Infrastructure/Capacitor/HunterNative.ts. The TWA has no
// Capacitor bridge, so the only way to reach native code is a Chrome intent:// URI: it
// dispatches an Android Intent to the exported HunterActivity in the TWA package
// (src/BLogic.Moone.Android), which presents hunter full-screen in a chromeless native
// WebView — a TOP-LEVEL document, so hunter's frame-ancestors / X-Frame-Options don't
// apply (an iframe embed would be blocked). Chrome fires the intent without navigating
// the page away; on app versions that predate HunterActivity it falls back to
// navigating the tab to hunter directly (off-origin, so Chrome's Custom Tab toolbar
// appears and back returns to the app). Only call this when isAndroidTwa() is true.
export const openHunterTwa = () => {
  window.location.href =
    "intent://hunter#Intent;scheme=moone;package=one.mo.app.twa;" +
    `S.url=${encodeURIComponent(HUNTER_URL)};` +
    `S.browser_fallback_url=${encodeURIComponent(HUNTER_URL)};end`;
};
